import { createSlice, PayloadAction } from '@reduxjs/toolkit';

import { fetchTableConfigAction } from '../../apiActions/fetchTableConfigAction';

const initialState: {
  areBlockingResourcesReady: boolean;
  isReadyToRender: boolean;
  isLayoutRendered: boolean;
  error: Error | null;
} = {
  areBlockingResourcesReady: false,
  isReadyToRender: false,
  isLayoutRendered: false,
  error: null,
};

export const initializationSlice = createSlice({
  name: 'initialization',
  initialState,
  reducers: {
    setBlockingResourcesReady: (state, action: PayloadAction<boolean>) => {
      state.areBlockingResourcesReady = action.payload;
    },
    setIsReadyToRender: (state, action: PayloadAction<boolean>) => {
      state.isReadyToRender = action.payload;
    },
    setIsLayoutRendered: (state, action: PayloadAction<boolean>) => {
      state.isLayoutRendered = action.payload;
    },
  },
  extraReducers: (builder) => {
    builder.addCase(fetchTableConfigAction.rejected, (state, action) => {
      state.error = action.error as Error;
    });
  },
});

export const initializationActions = initializationSlice.actions;
